import type { ObserveConnection, ObserveStatus } from './useApiObserve';

const STATUS_ORDER: Record<ObserveStatus, number> = {
  active: 0,
  stale: 1,
  down: 2,
  never: 3,
};

export function sortConnections(connections: ObserveConnection[]): ObserveConnection[] {
  return [...connections].sort((a, b) => {
    const sa = STATUS_ORDER[a.status] ?? 9;
    const sb = STATUS_ORDER[b.status] ?? 9;
    if (sa !== sb) return sa - sb;
    return (b.total_calls_24h || 0) - (a.total_calls_24h || 0);
  });
}

export function formatRelativeTime(iso: string | null): string {
  if (!iso) return 'never';
  const ms = Date.now() - new Date(iso).getTime();
  if (!Number.isFinite(ms) || ms < 0) return 'just now';
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return `${sec} sec ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 48) return `${hr} hour${hr === 1 ? '' : 's'} ago`;
  const day = Math.floor(hr / 24);
  return `${day} day${day === 1 ? '' : 's'} ago`;
}

export function statusDotColor(status: ObserveStatus): string {
  if (status === 'active') return '#22c55e';
  if (status === 'stale') return '#f59e0b';
  return '#ef4444';
}

export function errorRateColor(rate: number | null): string {
  if (rate == null) return 'text-gray-500';
  if (rate < 5) return 'text-green-600';
  if (rate <= 20) return 'text-amber-600';
  return 'text-red-600';
}
